import request from '@/utils/request'

export function selectWaste(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/material/selectWaste?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}

export function addWaste(data) {
    return request({
        url: `api/serviceCenter/material/addWaste`,
        method: 'post',
        data,
    })
}

export function wasteTpDownLoad(data) {
    return request({
        url: `api/serviceCenter/material/wasteTpDownLoad`,
        method: 'post',
        data,
    })
}


export function selectWasteMaterialType(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/material/selectWasteMaterialType`,
        method: 'post',
        data,
    })
}

export function wasteUpdateComposition(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/material/wasteUpdateComposition?`,
        method: 'post',
        data,
    })
}
export function wasteUnUpdateComposition(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/material/wasteUnUpdateComposition?`,
        method: 'post',
        data,
    })
}

export function wasteBatchDelete(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/material/wasteBatchDelete?`,
        method: 'post',
        data,
    })
}
